import { Shell } from './shell/Shell'
import { renderPage } from './pages/renderPage'

export function App() {
  return <Shell renderPage={renderPage} />
}
